import JSZip from 'jszip';

/**
 * 查找某个匹配的路由
 * @param {*} path
 * @param {*} RootRoutes
 * @returns
 */
export const findRouterPath = (path, RootRoutes) => {
  for (let i = 0; i < RootRoutes.length; i++) {
    const route = RootRoutes[i];

    if (route.path == undefined) {
      continue;
    }

    if (route.path === path) {
      return route;
    }

    let pAy = route.path.split('/');
    let pAy2 = path.split('/');
    if (pAy[pAy.length - 1][0] == ':' && pAy.length == pAy2.length) {
      return route;
    }

    if (route.children) {
      const childRoute = findRouterPath(path, route.children);

      if (childRoute) {
        return childRoute;
      }
    }
  }

  return null;
};

/**
 * 保存文件
 * @param {*} param0
 * fileName 文件名称
 * addFileCallback 添加文件回调
 */
export const saveFile = async ({
  fileName,
  addFileCallback,
  isSaveAsZip = true,
}) => {
  let jszip = new JSZip();

  await addFileCallback(jszip);

  let content = await jszip.generateAsync({
    type: 'blob',
  });
  if (isSaveAsZip) {
    downloadFile(fileName, content);
    return;
  } else {
    return content;
  }
};

export const downloadFile = (fileName, content) => {
  const a = document.createElement('a');
  const url = URL.createObjectURL(content);
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * 通过 XMLHttpRequest 下载文件并触发浏览器保存。
 *
 * 支持 onProgress 回调以展示下载百分比；下载完成后通过 Blob URL 触发保存。
 * 注意：跨域 URL 的文件名最终由服务端 Content-Disposition 决定，
 * 若服务端未指定，浏览器可能使用 URL 路径中的文件名。
 *
 * @param {string} url 下载地址
 * @param {string} [fileName] 期望的文件名
 * @param {(percent: number) => void} [onProgress] 进度回调（0-100）
 * @returns {Promise<void>}
 */
export const downloadUrl = (url, fileName, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onprogress = (event) => {
      if (event.lengthComputable && typeof onProgress === 'function') {
        const percent = Math.round((event.loaded / event.total) * 100);
        onProgress(percent);
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const blobUrl = URL.createObjectURL(xhr.response);
        const a = document.createElement('a');
        a.href = blobUrl;
        if (fileName) {
          a.download = fileName;
        }
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
        resolve();
      } else {
        reject(new Error(`下载失败: ${xhr.status}`));
      }
    };

    xhr.onerror = () => reject(new Error('下载失败'));
    xhr.onabort = () => reject(new Error('下载已取消'));
    xhr.send();
  }).catch(() => {
    // 回退：直接下载（跨域场景下文件名可能仍受浏览器限制）
    const a = document.createElement('a');
    a.href = url;
    if (fileName) {
      a.download = fileName;
    }
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
};

const fileDataType = {
  json: 'application/json',
  bin: 'application/octet-stream',
  zip: 'application/zip',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  onnx: '',
};
export const dataToFileData = (fileName, data, type) => {
  let ext = fileName.endsWith(`.${type}`) ? '' : `.${type}`;
  return new File([data], `${fileName}${ext}`, {
    type: fileDataType[type],
  });
};

export const imageBase64ToArrayBuffer = (base64) => {
  let binary = atob(base64.split(',')[1]);
  let len = binary.length;
  let view = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  return view.buffer;
};

let minMaxValues = {
  min: [],
  max: [],
};
export const normalizeData = (data, isReset = false) => {
  if (isReset) {
    minMaxValues = {
      min: [],
      max: [],
    };
  }

  if (minMaxValues.min.length === 0 || minMaxValues.max.length === 0) {
    // 初始化最小值和最大值
    minMaxValues.min = Array(data[0].length).fill(Infinity);
    minMaxValues.max = Array(data[0].length).fill(-Infinity);

    // 计算最小值和最大值
    for (const sample of data) {
      for (let i = 0; i < sample.length; i++) {
        if (sample[i] < minMaxValues.min[i]) {
          minMaxValues.min[i] = sample[i];
        }
        if (sample[i] > minMaxValues.max[i]) {
          minMaxValues.max[i] = sample[i];
        }
      }
    }
  }

  // 归一化数据
  const normalizedData = [];
  for (const sample of data) {
    const normalizedSample = [];
    for (let i = 0; i < sample.length; i++) {
      const range = minMaxValues.max[i] - minMaxValues.min[i];
      if (range === 0) {
        normalizedSample.push(0);
      } else {
        normalizedSample.push((sample[i] - minMaxValues.min[i]) / range);
      }
    }
    normalizedData.push(normalizedSample);
  }

  return normalizedData;
};

export const getNormalizeMinMaxValue = () => {
  return minMaxValues;
};
export const setNormalizeMinMaxValue = (data) => {
  minMaxValues = data;
};

// 提取关键点数据
export const extractKeypoints = (landmarks) => {
  const keypoints = [];
  for (const point of landmarks) {
    keypoints.push(point.x, point.y, point.z);
  }
  return keypoints;
};

// 延迟执行
export const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};

export const yixiaoMessage = (message) => {
  if (window.cFunNotifyAiWebErr) {
    window.cFunNotifyAiWebErr(`{errId:10001,msg:"${message}"}`);
  }
};

/**
 *
 * @param {number} byteSize
 */
export const byteFormat = (byteSize) => {
  let i = 0;
  let unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  while (byteSize >= 1024) {
    byteSize /= 1024;
    i++;
  }
  return `${byteSize.toFixed(1)}${unit[i]}`;
};

export const fetchImageUrlToFile = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], 'image.png', { type: 'image/png' });
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const unpack = async (url, option) => {
  const zip = new JSZip();
  const unpackData = await zip.loadAsync(url, option);
  return unpackData;
};

/**
 * 新窗口打开地址
 * @param {*} url
 * @param {*} option
 */
export const openBrowser = (url, option) => {
  if (window.OpenBrowser) {
    window.OpenBrowser(url);
  } else {
    window.open(url, option);
  }
};
